
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.video-wrapper{
  height:100%;
  width:100%;
  object-fit:cover;
  aspect-ratio:16/9;
  position:relative;
}

  .video-wrapper.video-ratio--single_4x3{
    aspect-ratio:4/3;
  }

  .video-wrapper.video-ratio--gallery{
    aspect-ratio:4/3.5;
    max-width:1200px;
    margin:0 auto;
  }

  @media (min-width: 640px){

  .video-wrapper.video-ratio--gallery{
      aspect-ratio:4/3
  }
    }
`;